const body = document.querySelector('body');
const banner = document.querySelector('section.hero');
const menuTrigger = document.querySelector('button.menu-toggle');
const desktopCta = document.querySelector('div.desktop-fixed-cta');

function updateMenuTrigger() {
    const bannerBottomPosition = banner ? banner.offsetHeight : 400;
    let scrollPosition = window.pageYOffset;

    // console.log(bannerBottomPosition, scrollPosition);

    if (menuTrigger) {
        if (scrollPosition > bannerBottomPosition) {
            body.classList.add('sticky-menu');

            if(desktopCta){
                desktopCta.classList.add('show');
            }
        } else {
            body.classList.remove('sticky-menu');

            if(desktopCta){
                desktopCta.classList.remove('show');
            }
        }
    }
}

// Throttle function to improve performance
function throttle(fn, wait) {
    let lastTime = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastTime >= wait) {
            fn(...args);
            lastTime = now;
        }
    };
}

['resize', 'scroll'].forEach(event => {
    window.addEventListener(event, throttle(updateMenuTrigger, 20));
});

const headerMenu = document.querySelector('.header-menu');
const headerMenuParents = headerMenu ? headerMenu.querySelectorAll('.menu-item-has-children') : [];

function closeHeaderSubmenus(currentItem = null) {
    headerMenuParents.forEach(item => {
        if (item !== currentItem) {
            item.classList.remove('submenu-open');
            item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
        }
    });
}

headerMenuParents.forEach(item => {
    const trigger = item.querySelector(':scope > a');

    if (!trigger) {
        return;
    }

    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('click', event => {
        event.preventDefault();
        const shouldOpen = !item.classList.contains('submenu-open');

        closeHeaderSubmenus(item);
        item.classList.toggle('submenu-open', shouldOpen);
        trigger.setAttribute('aria-expanded', shouldOpen.toString());
    });
});

document.addEventListener('click', event => {
    if (headerMenu && !headerMenu.contains(event.target)) {
        closeHeaderSubmenus();
    }
});

document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
        closeHeaderSubmenus();
    }
});
